import { handleCart } from "./utils/navbar-cart"
import { addListnerForAuthStateVisibility, handleSignOut, initFirebase } from "./utils/fbase"
import { removeAllChildNodes } from "./utils/helper-functions"
import addNavbarBurgerListner from "./utils/navbar-burger"

initFirebase()

document.addEventListener('DOMContentLoaded', () => {
    console.log("DOMContentLoaded")
    console.log(process.env.FBASE_APP_ID)

    addNavbarBurgerListner()
    addListnerForAuthStateVisibility()
    handleCart()

    try {
        const btn_signout_el = document.getElementById('btn_signout')
        btn_signout_el.addEventListener('click', () => {
            btn_signout_el.classList.add('is-loading')
            handleSignOut()
            btn_signout_el.classList.remove('is-loading')
        })
    } catch (error) {
        console.error("App: Could not add click event listner to #btn_signout.", error)
    }

    const container_catalogues = document.getElementById('container_catalogues')
    const cataloguesUrl = "https://static.nearlyfamous.ca/" + process.env.FBASE_APP_ID + "/catalogues.json"

    fetch(cataloguesUrl)
        .then(res => res.json())
        .then(catalogues => {
            let cataloguesArr = []
            Object.keys(catalogues).forEach(key => {
                cataloguesArr.push(catalogues[key])
            });

            return cataloguesArr.sort((a, b) => b.position - a.position)
        })
        .then(catalogues => {
            removeAllChildNodes(container_catalogues)

            catalogues.forEach(catalogue => {

                const el = document.createElement('div')
                el.classList.add("column", "is-one-quarter-widescreen", "is-one-third-desktop", "is-half-tablet")
                el.innerHTML = `
                                <div class="card">
                                    <div class="card-header">
                                        <h2 class="card-header-title is-fullheight">${catalogue.name}</h2>
                                        <span class="card-header-icon has-cursor-default"><strong class="has-text-primary has-animation-blink">${catalogue.specialText}</strong></span>
                                    </div>
                                    <div class="card-image">
                                        <figure class="image">
                                            <img src="${catalogue.image}" alt="Cover of ${catalogue.name} catalogue">
                                        </figure>
                                        <div class="card-content">
                                            <p>${catalogue.description}</p>
                                        </div>
                                    </div>
                                    <div class="card-footer">
                                        <a target="_blank" href="${catalogue.pdf}" class="card-footer-item is-hidden-signed-in has-text-centered">Download</a>
                                        <a target="_blank" href="${catalogue.pdfPriced}" class="card-footer-item is-hidden-signed-out has-text-centered">Download (priced)</a>
                                        <a target="_blank" href="${catalogue.pdfOrderForm}" class="card-footer-item is-hidden-signed-out has-text-centered">Order form</a>
                                    </div>
                                </div>
                                `

                container_catalogues.appendChild(el)
            })
        })
})